import React from 'react';
import { Button } from '../../components/ui/button';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../../components/ui/accordion';
import { Save } from 'lucide-react';
import { defaultHowWeHelpContent } from '../../siteContent';
import { useCms, Text, Lines, ImageField } from './cmsShared';

const AdminContentHowWeHelp = () => {
  const { content, update, uploadImage, save, saving } = useCms('howwehelp', defaultHowWeHelpContent);
  const c = content;

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="font-heading text-xl font-bold text-[#003366]">How We Help — Content</h2>
          <p className="text-sm text-gray-500">Edit the hero, each pillar's text and photo, and the difference points.</p>
        </div>
        <Button onClick={save} disabled={saving} data-testid="cms-hwh-save-btn" className="rounded-full bg-[#E74C3C] hover:bg-[#C0392B]"><Save className="w-4 h-4 mr-2" />{saving ? 'Saving…' : 'Save Changes'}</Button>
      </div>

      <Accordion type="multiple" defaultValue={['hero', 'pillars']} className="space-y-2">
        <AccordionItem value="hero" className="border rounded-xl px-4 bg-white">
          <AccordionTrigger data-testid="cms-hwh-section-hero">Hero</AccordionTrigger>
          <AccordionContent>
            <Text label="Eyebrow" value={c.hero.eyebrow} onChange={(v) => update(['hero', 'eyebrow'], v)} testid="cms-hwh-hero-eyebrow" />
            <Text label="Heading" value={c.hero.heading} onChange={(v) => update(['hero', 'heading'], v)} area testid="cms-hwh-hero-heading" />
            <Text label="Subtext" value={c.hero.subtext} onChange={(v) => update(['hero', 'subtext'], v)} area />
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="pillars" className="border rounded-xl px-4 bg-white">
          <AccordionTrigger data-testid="cms-hwh-section-pillars">Pillars (text & photos)</AccordionTrigger>
          <AccordionContent>
            {(c.pillars || []).map((p, i) => (
              <div key={i} className="border rounded-lg p-3 mb-4 bg-gray-50">
                <Text label={`Pillar ${i + 1} title`} value={p.title} onChange={(v) => update(['pillars', i, 'title'], v)} testid={`cms-hwh-pillar-${i}-title`} />
                <Lines label={`Pillar ${i + 1} points`} value={p.points} onChange={(v) => update(['pillars', i, 'points'], v)} />
                <Text label="Note (optional)" value={p.note} onChange={(v) => update(['pillars', i, 'note'], v)} area />
                <ImageField label={`Pillar ${i + 1} photo`} value={p.image} onChange={(v) => update(['pillars', i, 'image'], v)} onUpload={(f) => uploadImage(['pillars', i, 'image'], f)} testid={`cms-hwh-pillar-${i}-image`} />
              </div>
            ))}
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="difference" className="border rounded-xl px-4 bg-white">
          <AccordionTrigger>Difference band</AccordionTrigger>
          <AccordionContent>
            <Text label="Heading" value={c.difference.heading} onChange={(v) => update(['difference', 'heading'], v)} />
            <Lines label="Difference items" value={c.difference.items} onChange={(v) => update(['difference', 'items'], v)} />
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="cta" className="border rounded-xl px-4 bg-white">
          <AccordionTrigger>Closing CTA</AccordionTrigger>
          <AccordionContent>
            <Text label="CTA heading" value={c.ctaHeading} onChange={(v) => update(['ctaHeading'], v)} area />
          </AccordionContent>
        </AccordionItem>
      </Accordion>

      <div className="flex justify-end mt-6">
        <Button onClick={save} disabled={saving} className="rounded-full bg-[#E74C3C] hover:bg-[#C0392B]"><Save className="w-4 h-4 mr-2" />{saving ? 'Saving…' : 'Save Changes'}</Button>
      </div>
    </div>
  );
};

export default AdminContentHowWeHelp;
